import styled from 'styled-components'
import { NavLink as Link } from 'react-router-dom'

const TabContainer = styled.menu`
${({ theme: { colors } }) => `
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  max-width: 100%;
  overflow: scroll;
  border-bottom: 1px solid ${colors('foreground', 0.15)};
  gap: 0;
  &::-webkit-scrollbar {
    display: none;
  }
`}
`

export const TabPanel = styled.div`
  padding: 1rem 0;
`

const TabLink = styled(Link)`
${({ theme: { colors, monoFont } }) => `
  padding: 0.5rem 1rem;
  font-family: ${monoFont};
  font-size: 0.75rem;
  letter-spacing: 0.06em;
  color: ${colors('foreground', 0.45)};
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  white-space: nowrap;
  &:visited{
    color: ${colors('foreground', 0.45)};
  }
  &:hover{
    color: ${colors('text')};
  }
  &.active{
    color: ${colors('link')};
    border-bottom-color: ${colors('link')};
  }
`}
`

export const Tab = ({ children, ...rest }) => {
  return <TabLink {...rest}>{children}</TabLink>
}

export const Tabs = ({ children }) => {
  return <TabContainer>
      {children}
    </TabContainer>
}
